import type { Decamelized } from 'humps';

import type { CreateSessionPayload } from '../sessions';

type CreateMapper = {
  mapToBackend: (
    params: CreateSessionPayload,
  ) => Decamelized<CreateSessionPayload>;
};
export const createMapper: CreateMapper = {
  mapToBackend: params => {
    const {
      paymentMethodToken,
      recipientId,
      sessionType,
      directDebitProcessor,
      payor,
      mandateAch,
    } = params;
    return {
      payment_method_token: paymentMethodToken,
      recipient_id: recipientId,
      session_type: sessionType,
      direct_debit_processor: directDebitProcessor,
      payor: payor
        ? {
            first_name: payor?.firstName,
            last_name: payor?.lastName,
            email: payor?.email,
            phone: payor?.phone,
            address: payor?.address,
            country: payor?.country,
            city: payor?.city,
            state: payor?.state,
            zip: payor?.zip,
          }
        : undefined,
      mandate_ach: mandateAch
        ? {
            init_date: mandateAch.initDate,
            final_date: mandateAch.finalDate,
            number_of_payments: mandateAch.numberOfPayments,
          }
        : undefined,
    };
  },
};
